// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tarnsfer_form .payout-group--content-width .form-control-filtered-wrapper,.tarnsfer_form .payout-group--content-width .form-control-filtered-wrapper .form-control-filtered,.tarnsfer_form .payout-group--content-width input[type=text]{width:100%!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
